// Form configuration for Dental Insurance Enrollment
const formConfig = {
  tabs: [
    {
      title: "Personal Information",
      fields: [
        { label: "Patient Name", name: "customerName", type: "text", required: true },
        { label: "Date of Birth", name: "dob", type: "date", required: true },
        { label: "Email", name: "email", type: "email", required: true },
        {
          label: "Gender",
          name: "customerGender",
          type: "radio",
          options: ["Male", "Female", "Others"],
          required: true
        },
        { label: "Mobile Number", name: "mobile", type: "number", required: true }
        // { label: "Address", name: "address", type: "textarea", required: true },

        // { label: "City", name: "city", type: "text", required: true },
        // { label: "State", name: "state", type: "text", required: true },
        // { label: "Pincode", name: "pincode", type: "Number", required: true }
      ]
    },
    {
      title: "Dental Status",
      fields: [
        {
          label: "Are you currently undergoing any dental treatment?",
          name: "currentTreatment",
          type: "radio",
          options: ["Yes", "No"],
          required: true
        },
        {
          label: "Any ongoing dental treatment?",
          name: "ongoingProcedure",
          type: "text",
          required: false,
          dependsOn: { field: "currentTreatment", value: "Yes" }
        },
        {
          label: " Is there any pending ongoing treatment?",
          name: "pendingTreatment",
          type: "radio",
          options: ["Yes", "No"],
          required: true
        },
        {
          label: "Any pending dental procedure?",
          name: "pendingProcedure",
          type: "text",
          required: false,
          dependsOn: { field: "pendingTreatment", value: "Yes" }
        },
        {
          label: "Have you experienced any persistent tooth pain, swelling or bleeding from your gums in the past 12 months ? ",
          name: "painBleeding",
          type: "radio",
          options: ["Yes", "No"],
          required: true
        },
        {
          label: "Do you smoke or chew paan / tobacco?  ",
          name: "smokeTobacco",
          type: "radio",
          options: ["Yes", "No"],
          required: true
        },

        // {
        //   label: "Last dental check-up",
        //   name: "lastCheckup",
        //   type: "select",
        //   options: ["Less than 6 months", "6-12 months", "1-2 years", "More than 2 years", "Never"],
        //   required: true
        // }
      ]
    },
    {
      title: "Medical Status",
      fields: [
        {
          label: "Do you suffer from any of the following medical conditions?",
          name: "medicalConditions",
          type: "multiselect",
          options: [
            "Diabetes",
            "Blood Pressure",
            "Asthma",
            "Heart Disease",
            "Acidity / Ulcer",
            "Thyroid problem",
            "Epilepsy",
            "Jaundice",
            "Any other medical conditions",
            "Nil",

          ],
          required: true,

        },
        {
          label: "Please specify other medical conditions",
          name: "otherMedicalConditions",
          type: "text",
          required: false,
          dependsOn: { field: "medicalConditions", value: "Any other medical conditions", includeIn: "multiselect" }
        }
      ]
    },
    {
      title: "KYC Details",
      fields: [
        // { label: "Account Number", name: "accountNumber", type: "text", required: true },
        // { label: "Account Valid from", name: "avf", type: "date", required: true },
        // { label: "Account Valid To", name: "avt", type: "date", required: true },

        // { label: "Annual Income", name: "annualIncome", type: "select", options: ["Below ₹5 Lakhs", "₹5-10 Lakhs", "₹10-15 Lakhs", "Above ₹15 Lakhs"], required: true },
        { label: "Aadhaar Card", name: "aadhaarCard", type: "fileUpload", required: true },
        { label: "Aadhaar Card Back side", name: "aadhaarCardBack", type: "fileUpload" },

        { label: "PAN Card", name: "panCard", type: "fileUpload", required: true },
        // { label: "Account holder Address", name: "proposerAddress", type: "textarea", required: false },
        // { label: "Account holder City", name: "proposerCity", type: "text", required: true },
        // { label: "Account holder State", name: "proposerState", type: "text", required: true },

      ]
    },
    {
      title: "Nominee Details",
      fields: [
        { label: "Nominee Name", name: "nomineeName", type: "text", required: true },
        { label: "Nominee Relationship", name: "nomineeRelationship", type: "select", options: ["Spouse", "Child", "Parent", "Sibling", "Other"], required: true },
        { label: "Nominee Date of Birth", name: "nomineeDob", type: "date", required: true },
        {
          label: "Nominee Gender",
          name: "nomineeGender",
          type: "radio",
          options: ["male", "female", "other"],
          required: true
        },
        { label: "Nominee Contact Number", name: "nomineeContact", type: "number", required: true },

        { label: "Nominee Address", name: "nomineeAddress", type: "textarea", required: false },
        { label: "Same as Applicant Address", name: "sameAsApplicant", type: "checkbox", required: false }
      ]
    },
    {
      title: "Health Disclaimer & Declaration",
      fields: [
        {
          type: "label",
          name: "healthDisclaimerText",
          label: `Health Disclaimer\nI declare that I, the proposed insured member, have not been diagnosed with or treated for any of the following: heart disease, stroke, cancer, neurological disorders (such as epilepsy or paralysis), chronic lung disease, kidney or liver diseases, severe mental health conditions, autoimmune disorders, HIV/AIDS, Genetic disorders, or any physical disability or chronic illness. I understand that if I, the proposed insured member has not declared any of these conditions, the policy will be declined.`
        },
        {
          label: "Kindly Specify Yes/No",
          name: "healthDeclared",
          type: "radio",
          options: ["Yes", "No"],
          required: true
        },
        {
          label: "If yes, provide details",
          name: "healthDetails",
          type: "textarea",
          required: false,
          dependsOn: { field: "healthDeclared", value: "Yes" }
        },
        {
          type: "label",
          name: "customerDisclaimer",
          label: `Disclaimer for the Customer\n"The primary duty of the proposer is to fill out the proposal form and also to make sure that the proposal contains all the details correctly. If you or any of the insured person(s) have suffered or suffering from any of the diseases which has not been mentioned in the proposal, the claim that may arise will result in a repudiation of the claim/cancellation of the policy.\n\nI/we agree that the PAN details and other information provided by me/us in the proposal may be used by the Company to download/ verify / modify / add my/our KYC documents from the CERSAI* CKYC portal for processing this application. I/We understand that only the acceptable officially valid documents would be relied upon for verifying the identity (Central Registry of Securitization and Asset Reconstruction and security Interest of India) I hereby consent to receiving information from Central KYC Registry through SMS / email at the above registered number/email address.\n\nI hereby declare, on my behalf and on behalf of all persons proposed to be insured, that the above statements, answers and/or particulars given by me are true and complete in all respects to the best of my knowledge and that I am authorized to propose on their behalf for the insurance. 2. I understand that the information provided by me will form the basis of the insurance policy, is subject to the Board approved underwriting policy of the insurer and that the policy will come into force only after full payment of the premium chargeable. 3. I further declare that I will notify in writing any change occurring in the occupation or general health of the life to be insured/proposer after the proposal has been submitted but before communication of the risk acceptance by the company. 4. I declare that I consent to the company seeking medical information from any doctor or from a hospital who/which at any time has attended on the person to be insured/proposer or from any past or present employer concerning anything which affects the physical or mental health of the person to be insured/proposer and seeking information from any insurer to whom an application for insurance on the person to be insured/proposer has been made for the purpose of underwriting the proposal and/or claim settlement. 5. I authorize the company to share information pertaining to my proposal including the medical records of the insured/proposer for the sole purpose of underwriting the proposal and /or claims settlement and with any Governmental and/or Regulatory authority, which includes IRDAI and the CKYC Registry through ABHA e. In case of any concealment, mis-description or non-disclosure of any facts, the policy issued based on this proposal shall be void and all rights to claim under this policy will be lost.\n\nI confirm that the payment is made through my card / bank account. I also confirm that the source of funds for premium paid under this policy is legal. I hereby confirm that the features of the product have been understood by me. I hereby authorize Star Health and Allied Insurance Company Limited to contact me. It will override my registry on the NCPR.`
        },
        {
          label: "I agree to the above declaration and disclaimers",
          name: "declarationAgreement",
          type: "checkbox",
          required: true
        }
      ]
    },
    {
      title: "Review & Submit",
      fields: [
        {
          label: "I agree to the terms and conditions",
          name: "termsAgreed",
          type: "checkbox",
          required: true
        },
        // {
        //   label: "Your Signature",
        //   name: "applicantSignature",
        //   type: "signature",
        //   required: true
        // }
      ]
    }
  ]
};

export default formConfig;
